import { DEV } from '@/api/config'
const manageFiles = require.context('.', true, /\.js$/)

let routesConfig = []
manageFiles.keys().forEach(key => {
  // 如果是index.js就跳过
  if (key === './index.js' || (!DEV && key === './user.js')) return
  routesConfig = routesConfig.concat(manageFiles(key).default) // 读取出文件中的default模块
})
export default routesConfig
